module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success-page"
  }, [_c('div', {
    staticClass: "success-page__header"
  }, [(!_vm.$store.state.logoURL) ? _c('img', {
    attrs: {
      "src": "https://assets-cdn.signable.co.uk/images/signable_cropped.svg"
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.$store.state.logoURL
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "success-page__content"
  }, [(_vm.status === 'cancelled') ? [_c('h3', [_vm._v(_vm._s(_vm.$t('envelopeComplete.envelopeCancelled')))]), _vm._v(" "), _c('message', {
    attrs: {
      "type": "error"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('envelopeComplete.envelopeCancelledMessage', {
    name: _vm.companyName
  })) + "\n      ")])] : (_vm.status === 'rejected') ? [_c('message', {
    attrs: {
      "type": "error"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('envelopeComplete.envelopeRejected')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('envelopeComplete.envelopeRejectedMessage')))])])] : (_vm.status === 'signed') ? [_c('message', {
    attrs: {
      "type": "success"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('envelopeComplete.envelopeAccepted')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('envelopeComplete.envelopeAcceptedMessage')))])]), _vm._v(" "), _c('a', {
    staticClass: "success-page__download",
    attrs: {
      "href": (_vm.url + "/envelope/download/" + (_vm.requestedEnvelope.envelope_fingerprint) + "/" + (_vm.requestedEnvelope.signature_fingerprint) + "/" + _vm.clientId)
    }
  }, [_vm._v(_vm._s(_vm.$t('envelopeComplete.download')))])] : (_vm.status === 'expired') ? [_c('message', {
    attrs: {
      "type": "error"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('envelopeComplete.envelopeExpired')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('envelopeComplete.envelopeExpiredMessage', {
    name: _vm.companyName
  })) + " ")])])] : [_c('message', {
    attrs: {
      "type": "warning"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('envelopeComplete.envelopeAwaiting')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('envelopeComplete.envelopeAwaitingMessage')))])])], _vm._v(" "), (_vm.status === 'signed' || _vm.status === 'sent') ? _c('div', {
    staticClass: "boxes"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('envelopeComplete.wasntThatEasy')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('envelopeComplete.promoMessage')))]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "grid__item grid__item--4"
  }, [_c('div', {
    staticClass: "boxes__item"
  }, [_c('div', {
    staticClass: "boxes__item__icon"
  }, [_c('icon', {
    attrs: {
      "name": "check",
      "height": "35",
      "width": "35"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "boxes__item__content"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('envelopeComplete.trackDocumentProgress')) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "grid__item grid__item--4"
  }, [_c('div', {
    staticClass: "boxes__item"
  }, [_c('div', {
    staticClass: "boxes__item__icon"
  }, [_c('icon', {
    attrs: {
      "name": "check",
      "height": "35",
      "width": "35"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "boxes__item__content"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('envelopeComplete.accessOTG')) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "grid__item grid__item--4"
  }, [_c('div', {
    staticClass: "boxes__item"
  }, [_c('div', {
    staticClass: "boxes__item__icon"
  }, [_c('icon', {
    attrs: {
      "name": "check",
      "height": "35",
      "width": "35"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "boxes__item__content"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('envelopeComplete.cutCosts')) + "\n            ")])])])])]) : _vm._e()], 2), _vm._v(" "), (_vm.$store.state.config.company_id !== '46460') ? [(_vm.status === 'signed' || _vm.status === 'sent') ? _c('div', {
    staticClass: "success-page__content"
  }, [_c('a', {
    staticClass: "success-page__sign-up",
    attrs: {
      "href": "https://app.signable.co.uk/signup-trial?utm_source=new-signing-page"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('envelopeComplete.signUpForTrial'))
    }
  })]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "success-page__content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('envelopeComplete.signedVia')))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://app.signable.co.uk/signup-trial?utm_source=new-signing-page"
    }
  }, [_vm._v("Signable.")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('envelopeComplete.nowNotNextWeek')))])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57cb0666","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EnvelopeComplete.vue
// module id = 1053
// module chunks = 1